import CheckboxField from "@/components/form/CheckboxField.vue"
import CurrencyField from "@/components/form/CurrencyField.vue"
import DateField from "@/components/form/DateField.vue"
import DynamicPhoneField from "@/components/form/DynamicPhoneField.vue"
import EmailField from "@/components/form/EmailField.vue"
import NumberField from "@/components/form/NumberField.vue"
import PhoneField from "@/components/form/PhoneField.vue"
import SelectField from "@/components/form/SelectField.vue"
import SsnField from "@/components/form/SsnField.vue"
import TextField from "@/components/form/TextField.vue"
import ZipCodeField from "@/components/form/ZipCodeField.vue"
import StateField from "@/components/form/StateField.vue"
import RadioField from "@/components/form/RadioField.vue"

const descriptorByType = {
    checkbox: {
        component: CheckboxField,
    },

    currency: {
        component: CurrencyField,
    },

    date: {
        component: DateField,
    },

    dynamicPhone: {
        component: DynamicPhoneField,
    },

    email: {
        component: EmailField,
    },

    number: {
        component: NumberField,
    },

    phone: {
        component: PhoneField,
    },

    radio: {
        component: RadioField,
    },

    select: {
        component: SelectField,
    },

    state: {
        component: StateField,
    },

    ssn: {
        component: SsnField,
    },

    text: {
        component: TextField,
    },

    zipCode: {
        component: ZipCodeField,
    },
}

export const getFieldDescriptor = function (config) {
    let descriptor = descriptorByType[config.type]
    if (!descriptor) {
        console.warn("No descriptor for type: " + config.type)
        descriptor = descriptorByType["text"]
    }
    return descriptor
}
